"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPatchRequestBody = void 0;
var createPatchRequestBody = function createPatchRequestBody(originalObject, updateObject) {
  var patchRequestBody = [];
  Object.entries(updateObject).forEach(function (entry) {
    var propertyName = entry[0];
    var propertyValue = typeof entry[1] === "string" ? entry[1].trim() : entry[1];
    if (originalObject.hasOwnProperty(propertyName)) {
      if (originalObject[propertyName] !== propertyValue) {
        patchRequestBody.push({
          op: "replace",
          path: "/" + propertyName,
          value: propertyValue
        });
      }
    } else {
      patchRequestBody.push({
        op: "add",
        path: "/" + propertyName,
        value: propertyValue
      });
    }
  });
  return patchRequestBody;
};
exports.createPatchRequestBody = createPatchRequestBody;